module.exports = __webpack_public_path__ + "media/images/emblems/CollexBossy-coat_of_arms-d946bcc06b2fa4b49db143a1354c2e42.svg";